import React from 'react';
import notFound from '../../brand/generated/notFound.svg';

const Empty = ({ title = 'ÐÐ¾ Ð²Ð°ÑÐµÐ¼Ñ Ð·Ð°Ð¿ÑÐ¾ÑÑ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð¾. ÐÐ¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ Ð¿Ð¾Ð¸ÑÐºÐ°.' }) => {
  return (
    <div style={{ marginTop: '20px' }}>
      <p
        style={{
          fontWeight: '400',
          fontSize: '16px',
          lineHeight: '20px',
          marginBottom: '22px',
          textAlign: 'center',
        }}
      >
        {title}
      </p>
      <img src={notFound} alt="Icon" style={{ display: 'block', margin: 'auto' }} />
    </div>
  );
};

export default Empty;
